// Size Guide CM to Inch Toggle - Excluding First Column
document.addEventListener('DOMContentLoaded', function() {
  // Function to add the toggle and set up the conversion
  function setupSizeGuideToggle() {
    // Find the size guide table
    const sizeTable = document.querySelector('.sizeguide__table');
    if (!sizeTable) return;
    
    // Create a simple button-based toggle
    const toggleContainer = document.createElement('div');
    toggleContainer.innerHTML = `
      <div style="text-align: right; margin-bottom: 10px; padding: 5px;">
        <button id="cmInchToggle" class="button-cm" style="cursor: pointer;">
          Switch to Inches
        </button>
      </div>
    `;
    
    // Insert toggle before the size guide table
    sizeTable.parentNode.insertBefore(toggleContainer, sizeTable);
    
    // Store original CM values, but skip first column cells
    const rows = sizeTable.querySelectorAll('tr');
    rows.forEach(row => {
      const cells = row.querySelectorAll('td');
      
      // Process each cell, skipping the first one in each row
      for (let i = 1; i < cells.length; i++) {
        const cell = cells[i];
        const text = cell.textContent.trim();
        if (!isNaN(parseFloat(text))) {
          cell.setAttribute('data-cm', text);
        }
      }
    });
    
    // Set up toggle functionality with a simple button
    let showingInches = false;
    const toggleButton = document.getElementById('cmInchToggle');
    
    toggleButton.addEventListener('click', function() {
      showingInches = !showingInches;
      
      // Update button text
      this.textContent = showingInches ? 'Switch to CM' : 'Switch to Inches';
      
      // Convert values in all cells except first column
      rows.forEach(row => {
        const cells = row.querySelectorAll('td');
        
        // Skip first cell in each row
        for (let i = 1; i < cells.length; i++) {
          const cell = cells[i];
          const cmValue = cell.getAttribute('data-cm');
          if (cmValue) {
            if (showingInches) {
              // Convert CM to inches (1 cm = 0.393701 inches)
              const inchValue = (parseFloat(cmValue) * 0.393701).toFixed(1);
              cell.textContent = inchValue;
            } else {
              // Switch back to CM
              cell.textContent = cmValue;
            }
          }
        }
      });
    });
  }
  
  // Initial setup
  setupSizeGuideToggle();
  
  // For modals that might load after page load
  // Use MutationObserver to detect when new content is added to the DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Check if our table exists but toggle doesn't
        const sizeTable = document.querySelector('.sizeguide__table');
        const toggle = document.getElementById('cmInchToggle');
        if (sizeTable && !toggle) {
          setupSizeGuideToggle();
        }
      }
    });
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, { childList: true, subtree: true });
});
